import { ContentSettings } from "shared/types/Homework";
import { assignTaskDates, groupReportsBySchedule, parseDateString } from "shared/utils/reportScheduleUtils";

export const HOMEWORK_CALENDAR_CONCURRENCY = 12;

export interface HomeworkCalendarAssignment {
    release_id: string;
    distribution_id?: string;
    effective_date: { start: string; end: string };
    dayOfWeek: boolean[];
    interval: number;
    date: string;
    report: { id: string; path: string; order: number };
    report_setting?: ContentSettings | null;
}

/** 전체 배포 순서로 날짜를 계산한 뒤, 상세 조회할 월의 과제만 골라낸다. */
export const scheduleHomeworkAssignments = <T extends HomeworkCalendarAssignment>(
    assignments: T[],
    selectedMonth?: Date
): (T & { scheduledDate: Date })[] => {
    const entries = assignments.flatMap(assignment => {
        const date = parseDateString(assignment.date);
        if (assignment.date !== "" && !date) return [];
        return [{
            assignment,
            release_id: assignment.release_id,
            distribution_id: assignment.distribution_id,
            effective_date: assignment.effective_date,
            dayOfWeek: assignment.dayOfWeek,
            interval: assignment.interval,
            order: assignment.report.order,
            date,
            report: { ...assignment.report, title: "", folderPath: [] as string[] },
        }];
    });

    const scheduled = groupReportsBySchedule(entries).flatMap(group => {
        if (group[0].date) {
            return group.map(entry => ({ ...entry.assignment, scheduledDate: entry.date! }));
        }
        const ordered = [...group].sort((a, b) => a.order - b.order);
        return assignTaskDates(
            ordered, group[0].dayOfWeek, group[0].effective_date.start, group[0].interval || 1
        ).map(entry => ({ ...entry.assignment, scheduledDate: entry.assignedDate }));
    });

    if (!selectedMonth) return scheduled;
    return scheduled.filter(entry =>
        entry.scheduledDate.getFullYear() === selectedMonth.getFullYear() &&
        entry.scheduledDate.getMonth() === selectedMonth.getMonth()
    );
};
